import { jsx } from "react/jsx-runtime";
import { UnstyledButton } from "@zillow/constellation-10";
const CarouselDot = ({
  isActive,
  isContinuation,
  ...props
}) => /* @__PURE__ */ jsx(UnstyledButton, { ...props, css: {
  cursor: "pointer",
  display: "inline-block",
  width: isContinuation ? "4px" : "8px",
  height: isContinuation ? "4px" : "8px",
  // v8 colors.brand / gray300. Both tokens render the v8 hex exactly
  // in the zillow and legacy-zillow themes.
  backgroundColor: isActive ? "bg.accent.brand.hero" : "gray.300",
  borderRadius: "50%",
  verticalAlign: "middle",
  transition: "all 150ms linear 0s",
  marginBlock: "0",
  marginInline: "2px",
  _first: {
    marginInlineStart: "0"
  },
  _last: {
    marginInlineEnd: "0"
  },
  // v8 outlined on every :focus (mouse clicks included), not just :focus-visible.
  _focus: {
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: "border.action.hero.default"
  }
} });
export {
  CarouselDot as default
};
